import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  CButton, CCard, CCardBody, CCardGroup, CCol, CContainer,
  CForm, CFormInput, CInputGroup, CInputGroupText, CRow, CToaster, CToast, CToastBody
} from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { cilLockLocked, cilUser } from '@coreui/icons';
import api from '../../api/axiosInstance'; //

const Login = () => {
  const navigate = useNavigate();
  const [loginData, setLoginData] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(0);

  const handleChange = (e) => {
    setLoginData({ ...loginData, [e.target.name]: e.target.value });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post('/api/Members/Login', loginData);
      
      if (res.status === 200) {
        // Data ko localStorage mein save karein
        localStorage.setItem('authToken', res.data.token);
        localStorage.setItem('ID', res.data.id);
        localStorage.setItem('userName', res.data.fullName);

        navigate('/'); // Success ke baad redirect
      }
    } catch (err) {
      setToast(
        <CToast color="danger" className="text-white">
          <CToastBody>{err.response?.data?.message || "Login Failed"}</CToastBody>
        </CToast>
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-light min-vh-100 d-flex flex-row align-items-center">
      <CToaster push={toast} placement="top-end" />
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={8}>
            <CCardGroup className="shadow-lg">
              <CCard className="p-4 border-0">
                <CCardBody>
                  <CForm onSubmit={handleLogin}>
                    <h2 className="fw-bold text-primary">Login</h2>
                    <p className="text-muted">Sign In to your member account</p>
                    
                    <CInputGroup className="mb-3">
                      <CInputGroupText><CIcon icon={cilUser} size="sm" /></CInputGroupText>
                      <CFormInput 
                        name="email"
                        placeholder="Email Address" 
                        onChange={handleChange}
                        required 
                      />
                    </CInputGroup>
                    
                    <CInputGroup className="mb-4">
                      <CInputGroupText><CIcon icon={cilLockLocked} size="sm" /></CInputGroupText>
                      <CFormInput 
                        name="password"
                        type="password" 
                        placeholder="Password" 
                        onChange={handleChange}
                        required 
                      />
                    </CInputGroup>
                    
                    <CRow>
                      <CCol xs={6}>
                        <CButton color="primary" type="submit" className="px-4 fw-bold" disabled={loading}>
                          {loading ? 'Wait...' : 'Login'}
                        </CButton>
                      </CCol>
                      <CCol xs={6} className="text-end">
                        <CButton color="link" className="px-0" onClick={() => navigate('/register')}>
                          New User?
                        </CButton>
                      </CCol>
                    </CRow>
                  </CForm>
                </CCardBody>
              </CCard>
              
              <CCard className="text-white bg-primary py-5 border-0 d-md-down-none" style={{ width: '44%' }}>
                <CCardBody className="text-center d-flex flex-column justify-content-center">
                  <div>
                    <h2 className="fw-bold">Member Portal</h2>
                    <p className="mt-3">Access your courses and membership details.</p>
                    <CButton color="light" variant="outline" className="mt-3 fw-bold" onClick={() => navigate('/register')}>
                      Register Now!
                    </CButton>
                  </div>
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  );
};

export default Login;